const getters = {
  token: (state) => state.user.token,
  systemName: (state) => state.user.systemName,
};
export default getters;
